import Vue from 'vue';
import App from './App.vue';
import ElementUI from 'element-ui';
import 'default-passive-events'
// 复制粘贴
import VueClipboard from 'vue-clipboard2'
//打印
import Print from 'vue-print-nb'
import 'element-ui/lib/theme-chalk/index.css';
import jquery from 'jquery';
import router from './router';
import store from './store/';
// reset.css
import 'common/styles/reset.css';
// index.css
import 'common/styles/index.css';
import directives from 'common/js/directives'
// 兼容ie11
import '@babel/polyfill'
import * as echarts from 'echarts';

// sgv-icon 的处理
const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./icons', false, /\.svg$/)
requireAll(req)

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueClipboard);
Vue.use(Print);
Vue.prototype.$jq = jquery
Vue.prototype.$echarts = echarts;
// 页面跳转从顶部开始显示
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
